<script lang="ts" setup>

  type Props = {
    label: string
    link?: string
    itemKey: number
  }
  const props = defineProps<Props>()
</script>
<template>
  <div class="c-breadcrumb-item">
    <SvgIcon
      v-if="props.itemKey > 0"
      icon="chevron"
      :desktop-height="20"
      :desktop-width="10"
      :height="10"
      :width="5"
    />
    <NuxtLink
      v-if="props.link"
      :to="`${props.link}`"
    >
      {{ props.label }}
    </NuxtLink><!--
    --><span v-else>{{ props.label }}</span>
  </div>
</template>
<style scoped>
.c-breadcrumb-item {
  display: flex;
  flex-direction: row;
  padding: 0.5em 0;

  .c-icon {
    margin: 0 0.5em;
    color: var(--color-secondary);
    opacity: 0.8;
  }

  a,
  span {
    color: var(--color-secondary);
    font-family: Open-Sans, sans-serif;
    font-size: 1em;
    font-weight: 500;
    opacity: 0.8;
  }

  a {
    text-decoration: underline;
  }
}
</style>
